import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { TestTagModule } from "@lantern/app/common/test-tag";
import { IconModule } from "@lantern/app/common/utils/icon";
import { UserActionDirectivesModule } from "@lantern/app/common/utils/user-action-directives";
import { OverlaysModule } from "@lantern/app/core/utils/overlays";

import {
  NewOptionLayoutDirective,
  OptionLayoutDirective,
  SelectedOptionLayoutDirective
} from "./base";
import { MultiSelectComponent } from "./multi/multi-select.component";
import { MultiSelectPlaceholderLayoutDirective } from "./multi/placeholder-layout.directive";
import {
  SingleSelectComponent,
  SingleSelectPlaceholderLayoutDirective
} from "./single";

import { AdHocDefaultOptionLayoutsComponent } from "./shared/ad-hoc-option-layouts.component";
import { AdHocOptionsDirective } from "./shared/ad-hoc-options.directive";
import {
  MultiSelectDropdownNewOptionComponent,
  MultiSelectDropdownOptionComponent
} from "./shared/multi-select-dropdown-option.component";
import { MultiSelectDropdownComponent } from "./shared/multi-select-dropdown.component";
import { SelectDropdownOptionComponent } from "./shared/select-dropdown-option.component";
import { SelectDropdownComponent } from "./shared/select-dropdown.component";
import {
  AvailableOptionsListComponent,
  SelectedOptionsListComponent,
  TransferListComponent,
  TransferListOptionComponent
} from "./transfer-list";

@NgModule({
  imports: [
    CommonModule,
    IconModule,
    OverlaysModule,
    TestTagModule,
    UserActionDirectivesModule
  ],
  declarations: [
    OptionLayoutDirective,
    SelectedOptionLayoutDirective,
    NewOptionLayoutDirective,
    SelectDropdownComponent,
    MultiSelectDropdownComponent,
    SelectDropdownOptionComponent,
    MultiSelectDropdownOptionComponent,
    MultiSelectDropdownNewOptionComponent,
    AdHocOptionsDirective,
    AdHocDefaultOptionLayoutsComponent,
    SingleSelectComponent,
    MultiSelectComponent,
    TransferListComponent,
    AvailableOptionsListComponent,
    SelectedOptionsListComponent,
    TransferListOptionComponent,
    SingleSelectPlaceholderLayoutDirective,
    MultiSelectPlaceholderLayoutDirective
  ],
  entryComponents: [
    AdHocDefaultOptionLayoutsComponent,
    SelectDropdownComponent,
    MultiSelectDropdownComponent
  ],
  exports: [
    OptionLayoutDirective,
    SelectedOptionLayoutDirective,
    NewOptionLayoutDirective,
    SingleSelectPlaceholderLayoutDirective,
    MultiSelectPlaceholderLayoutDirective,
    AdHocOptionsDirective,
    SingleSelectComponent,
    MultiSelectComponent,
    TransferListComponent,
    SelectDropdownOptionComponent,
    SelectDropdownComponent
  ]
})
export class SelectModule {}
